const VIDEO_FILE_EXTENSIONS = /\.(mp4|webm|ogg|mov)(\?.*)?$/i;

export function isDirectVideoUrl(url: string): boolean {
	return VIDEO_FILE_EXTENSIONS.test(url);
}
